<!-- ootb implementation-->

<div class="row">
  <div class="component col-12 CustomCarousel">
    @if (carouselImages$| async; as data) {
      <div class="carousel col initialized">
        <div class="row">
          <p-galleria [value]="data" [autoPlay]="true" [circular]="true" [showItemNavigators]="false"
            [showThumbnails]="false" [showIndicators]="false" [(activeIndex)]="activeIndex">
            <ng-template pTemplate="item" let-item>
              <img src="{{ item }}" class="d-block mw-100 carousel-img" alt="product-image" />
            </ng-template>
          </p-galleria>
        </div>
        <div data-v-2dcb6341="" class="row homepage-carousel-navigation-container">
          <div data-v-2dcb6341="" class="col center-align-col">
            <a data-v-2dcb6341="" role="button" class="nav-btn-link">
              <i class="sg-icon sg-icon-arrow arrow-left" tabindex="0" (click)="prevSlide(data.length)"
              (keydown.enter)="prevSlide(data.length)" (keydown.space)="prevSlide(data.length)"></i>
            </a>
            <span class="carousel-number-active" data-v-2dcb6341="">{{activeIndex + 1 | number:'2.0'}}</span>
            <span class="carousel-number-total">{{data.length| number:'2.0'}}</span>
            <a role="button" class="nav-btn-link">
              <i class="sg-icon sg-icon-arrow " tabindex="0" (click)="nextSlide(data.length)"
              (keydown.enter)="nextSlide(data.length)" (keydown.space)="nextSlide(data.length)"></i>
            </a>
          </div>
        </div>
      </div>
    }
  </div>

  <!-- old implementation
  <div class="row">
    <div class="component col-12 CustomCarousel">
      <div class="carousel col initialized">
        <div class="row">
          <img src="{{listImg[i]}}" alt="Carousel {{i}}" class="d-block carousel-item-image mw-100"
            style="max-height: 500px; width: 100%;">
          </div>
          <div data-v-2dcb6341="" class="row homepage-carousel-navigation-container">
            <div data-v-2dcb6341="" class="col center-align-col">
              <a data-v-2dcb6341="" role="button" class="nav-btn-link">
                <i class="sg-icon sg-icon-arrow arrow-left" (click)="prevSlide()"></i>
              </a>
              <span class="carousel-number-active" data-v-2dcb6341="">{{i + 1 | number:'2.0'}}</span>
              <span class="carousel-number-total">{{lengthArray | number:'2.0'}}</span>
              <a role="button" class="nav-btn-link">
                <i class="sg-icon sg-icon-arrow " (click)="nextSlide()"></i>
              </a>
            </div>
          </div>
        </div>
      </div> -->